import React from 'react';
import PropTypes from 'prop-types';
import appConfig from 'config/app.config';
import {getText} from 'helpers/language-helper';
import {generalUiTexts } from 'data/ui-texts/general-ui-texts';
import {languagesData} from 'data/languages-data';
import Button from 'components/ui/button/button';
import './landing.scss';

const Landing = (props) => {
	const {
		languageId, 
		deviceInfo,
		playerData,
		handleGoToGamePage, 
		resetPlayerData
	} = props;


	/**
	 * Go to game
	 */
	const goToGame = () => {
		handleGoToGamePage('modules-overview');	
	};


	return (
		<div className={'Landing ' + deviceInfo.orientation}>
			<div className="Landing-header" />

			<div className="Landing-splash" />

			{playerData && <div className="Landing-buttons">
				<div className="Landing-startBtn">
					<Button 
						classes={['blueDark', 'fullHeight']}
						text={getText(generalUiTexts.start, languageId)}
						onClick={() => {goToGame();}}
					/>
				</div>
			
			</div>}

			{/* Reset btn */}
			{(playerData && (appConfig.env === 'development' || appConfig.env === 'test')) &&
				<div className={'Landing-resetBtn ' + deviceInfo.orientation}>
					<Button
						text={getText(generalUiTexts.reset, languageId)}
						classes={['reset']}
						onClick={() => {resetPlayerData();}}
					/>
				</div>
			}
			
			{/* Language btn */}
			{(playerData && languagesData.length > 1) &&
				<div className="Landing-languageBtn" > 
					<Button
						classes={['switch-language']}
						onClick={() => {handleGoToGamePage('choose-language');}}
					/>
				</div>
			}
		</div>
	);
};

Landing.propTypes = {
	languageId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	playerData: PropTypes.object,
	handleGoToGamePage: PropTypes.func.isRequired,
	resetPlayerData: PropTypes.func.isRequired
};

export default Landing;
